export const GET_ALL_ITEMS_CARRIED_REQUEST = 'GET_ALL_ITEMS_CARRIED_REQUEST';
export const GET_ALL_ITEMS_CARRIED_SUCCESS = 'GET_ALL_ITEMS_CARRIED_SUCCESS';
export const GET_ALL_ITEMS_CARRIED_FAILURE = 'GET_ALL_ITEMS_CARRIED_FAILURE';

export const ADD_ITEM_REQUEST = 'ADD_ITEM_REQUEST';
export const ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS';
export const ADD_ITEM_FAILURE = 'ADD_ITEM_FAILURE';

export const UPDATE_ITEM_REQUEST = 'UPDATE_ITEM_REQUEST';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const UPDATE_ITEM_FAILURE = 'UPDATE_ITEM_FAILURE';

export const UPDATE_ITEM_STATUS_REQUEST = 'UPDATE_ITEM_STATUS_REQUEST';
export const UPDATE_ITEM_STATUS_SUCCESS = 'UPDATE_ITEM_STATUS_SUCCESS';
export const UPDATE_ITEM_STATUS_FAILURE = 'UPDATE_ITEM_STATUS_FAILURE';
